import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  HomeIcon,
  HeartIcon,
  PlusIcon,
  InformationCircleIcon,
  UserIcon
} from '@heroicons/react/24/outline';
import {
  HomeIcon as HomeSolidIcon,
  HeartIcon as HeartSolidIcon,
  InformationCircleIcon as InformationCircleSolidIcon,
  UserIcon as UserSolidIcon
} from '@heroicons/react/24/solid';
import { useAuth } from '../contexts/AuthContext';

const MobileBottomNav: React.FC = () => {
  const location = useLocation();
  const { isAuthenticated, isAdminAuthenticated } = useAuth();

  // Hide navigation for admin users
  if (isAdminAuthenticated) {
    return null;
  }

  const navItems = [
    {
      name: 'Home',
      path: '/',
      icon: HomeIcon,
      activeIcon: HomeSolidIcon,
      label: 'خانه'
    },
    {
      name: 'Profile',
      path: isAuthenticated ? '/profile' : '/login',
      icon: UserIcon,
      activeIcon: UserSolidIcon,
      label: isAuthenticated ? 'پروفایل' : 'ورود'
    },
    {
      name: 'PostAd',
      path: '/post-ad',
      icon: PlusIcon,
      activeIcon: PlusIcon,
      label: 'ثبت آگهی',
      isCenter: true
    },
    {
      name: 'Favorites',
      path: '/favorites',
      icon: HeartIcon,
      activeIcon: HeartSolidIcon,
      label: 'علاقه‌مندی‌ها'
    },
    {
      name: 'About',
      path: '/about',
      icon: InformationCircleIcon,
      activeIcon: InformationCircleSolidIcon,
      label: 'درباره'
    }
  ];

  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 safe-area-pb">
      <div className="flex items-center justify-around py-3 xs:py-4 sm:py-5 px-1 xs:px-2 sm:px-3 relative">
        {navItems.map((item, index) => {
          const active = isActive(item.path);
          const IconComponent = active ? item.activeIcon : item.icon;
          
          if (item.isCenter) {
            return (
              <div key={item.name} className="flex flex-col items-center justify-center">
                <Link
                  to={item.path}
                  className="flex flex-col items-center justify-center"
                >
                  <div className="bg-red-600 hover:bg-red-700 active:bg-red-800 text-white rounded-full p-2.5 xs:p-3 sm:p-4 mb-0.5 xs:mb-1 shadow-lg transition-all duration-200 transform active:scale-95">
                    <IconComponent className="h-5 w-5 xs:h-6 xs:w-6 sm:h-7 sm:w-7" strokeWidth={3} />
                  </div>
                  <span className="text-[10px] xs:text-xs sm:text-xs font-medium text-gray-700 leading-tight">{item.label}</span>
                </Link>
              </div>
            );
          }
          
          return (
            <Link
              key={item.name}
              to={item.path}
              className="flex flex-col items-center justify-center py-1 xs:py-1.5 sm:py-2 px-1 xs:px-1.5 sm:px-2 transition-all duration-200 text-gray-500 hover:text-gray-700 active:text-gray-800 min-w-0 flex-1 max-w-[80px] active:scale-95"
            >
              <IconComponent className="h-4 w-4 xs:h-5 xs:w-5 sm:h-6 sm:w-6 mb-0.5 xs:mb-1 flex-shrink-0" />
              <span className="text-[9px] xs:text-[10px] sm:text-xs font-medium leading-tight text-center truncate w-full">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default MobileBottomNav; 